<script lang="ts">
  export let medal: number = 0;
  export let signature: any;
  export let br_signature_changes: any;

  let pp: number = signature && signature.pp;
  let ppDelta: number = br_signature_changes && signature.pp - br_signature_changes.pp;

  let hie: number = signature && signature.atc / 1000;
  let hieDelta: number = br_signature_changes && (signature.atc - br_signature_changes.atc) / 1000;

  let tp: number = signature && signature.ftp;
  let tpDelta: number = br_signature_changes && signature.ftp - br_signature_changes.ftp;

  function breakthroughColor(br) {
    if(medal == -1) return "background-color: black; background-image: linear-gradient(to right, gray, black);";
    else if(medal == 1) return "background-color: peru; background-image: linear-gradient(to right, peru , saddlebrown);";
    else if(medal == 2) return "background-color: silver; background-image: linear-gradient(to right, silver , grey);";
    else if(medal == 3) return "background-color: gold; background-image: linear-gradient(to right, gold , goldenrod);";
  }

  function tidy(number) {
    return Math.round(10 * Math.abs(number)) / 10;
  }

  // Formatting binds
  let ppSize: ResizeObserverSize[] | null = null;
  let hieSize: ResizeObserverSize[] | null = null;
  let tpSize: ResizeObserverSize[] | null = null;
  let bannerSize: ResizeObserverSize[] | null = null
  let bannerWidth: number | null = null;
  let dataWidth: number | null = null;
  $: if (bannerSize && bannerSize[0]) bannerWidth = bannerSize[0].inlineSize;
  $: if(ppSize && hieSize && tpSize && ppSize.length>0 && hieSize.length>0 && tpSize.length>0) {
    dataWidth = Math.max(isNaN(dataWidth) ? 0 : dataWidth, ppSize[0].inlineSize + hieSize[0].inlineSize + tpSize[0].inlineSize + 30);
  }
</script>


  <div class="banner" bind:borderBoxSize={bannerSize}>
    {#if medal}
    <h4 class="breakthrough" style={breakthroughColor(medal)}>
      {medal < 0 ? "Near" : ""} Breakthrough
    </h4>
    {/if}
    <div class="activity-stats">
      <span bind:borderBoxSize={ppSize} style={bannerWidth && dataWidth > bannerWidth && " display: flex; flex-direction: column;"}>
        <p>PP</p>
        <b>{tidy(pp)} W</b>
        {#if medal}
          <p style={ppDelta >= 0 ? "color: #5CA907;" : "color: #FF2222;"}>{ppDelta >= 0 ? "+" : "-"}{tidy(ppDelta)} W</p>
        {/if}
      </span>
      <div class="divider" />
      <span bind:borderBoxSize={hieSize} style={bannerWidth && dataWidth > bannerWidth && " display: flex; flex-direction: column;"}>
        <p>HIE</p>
        <b>{tidy(hie)} kJ</b>
        {#if medal}
          <p style={hieDelta >= 0 ? "color: #5CA907;" : "color: #FF2222;"}>{hieDelta >= 0 ? "+" : "-"}{tidy(hieDelta)} kJ</p>
        {/if}
      </span>
      <div class="divider"/>
      <span bind:borderBoxSize={tpSize} style={bannerWidth && dataWidth > bannerWidth && " display: flex; flex-direction: column;"}>
        <p>TP</p>
        <b>{tidy(tp)} W</b>
        {#if medal}
          <p style={tpDelta >= 0 ? "color: #5CA907;" : "color: #FF2222;"}>{tpDelta >= 0 ? "+" : "-"}{tidy(tpDelta)} W</p>
        {/if}
      </span>
    </div>
  </div>

<style lang="scss">

.banner {
  display: flex;
  flex-wrap: wrap;
  background-color: #F8F8F8;
  justify-content: space-evenly;
  border-radius: 5px;
  margin-bottom: 10px;

  .breakthrough {
    padding: 5px;
    margin: 0;
    width: 100%;
    color: floralwhite;
    border-radius: 5px;
    text-align: center;
    font-weight: 500;
  }

  .activity-stats {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    width: 100%;
  }

  .divider {
    border-right: 1px solid #E4E4E4;
    margin: 7px 0 !important;
  }

  span {
    margin: 7px 5px;
    white-space: nowrap;
  }

  p {
    font-size: 14px;
    line-height: 12px;
    margin: 2px 0;
  }

  b {
    font-size: 17px;
    font-weight: 500 !important;
  }
}

</style>